<template>
  <div>
    <b-card
      no-body
      class="mb-0 mt-1"
    >
      <b-card-header
        class="d-flex justify-content-between align-items-center"
      >
        <h5 class="mb-0">
          Equipos del contrato
        </h5>
        <b-button
          v-if="!working"
          variant="primary"
          size="sm"
          @click="search()"
        >
          <feather-icon icon="SearchIcon" />
          <span class="align-middle"> Consultar Equipos</span>
        </b-button>
        <b-button
          v-else
          variant="primary"
          size="sm"
          disabled
        >
          <b-spinner small />
          Procesando...
        </b-button>
      </b-card-header>
      <div class="m-2">
        <div class="d-flex justify-content-end mb-1">
          <b-form-input
            v-model="searchQuery"
            class="d-inline-block"
            style="max-width: 240px"
            placeholder="Buscar..."
          />
        </div>

        <div id="printEquipment">
          <b-table
            id="my-table"
            ref="refUserListTable"
            hover
            class="position-relative"
            :items="dataReport"
            responsive
            :fields="columns"
            :sort-by.sync="sortBy"
            show-empty
            :filter="searchQuery"
            empty-text="No existen registros para mostrar"
            :sort-desc.sync="isSortDirDesc"
            :per-page="perPage"
            :current-page="currentPage"
            small
            :busy="working"
          >
            <template #table-busy>
              <div class="text-center text-danger my-2">
                <b-spinner class="align-middle" />
                <strong>Cargando...</strong>
              </div>
            </template>
            <template #cell(serial)="dataRow">
              <b-media vertical-align="center">
                <template #aside>
                  <b-avatar
                    :id="`equipo-${dataRow.item.equipo.id}`"
                    size="30"
                    :variant="`light-${dataRow.item.equipo.tipoprodclass}`"
                  >
                    <feather-icon
                      :icon="
                        dataRow.item.equipo
                          .tipoprodicono
                      "
                    />
                  </b-avatar>
                </template>

                <div
                  class="font-weight-bold d-block text-nowrap"
                >
                  {{ dataRow.item.equipo.serial }}
                </div>
                <div>
                  <small class="text-muted">
                    {{ dataRow.item.equipo.box }}
                  </small>
                </div>
              </b-media>
            </template>

            <template #cell(estado)="dataRow">
              <b-badge
                pill
                :variant="dataRow.item.equipo.class"
              >
                {{ dataRow.item.equipo.name }}
              </b-badge>
            </template>

            <template #cell(equipo)="dataRow">
              <span
                v-if="
                  dataRow.item.equipo.equipo_olt != '' &&
                    dataRow.item.equipo.equipo_olt != null
                "
                class="d-block text-nowrap"
              >
                {{ dataRow.item.equipo.equipo_olt }}
              </span>
              <span
                v-if="
                  dataRow.item.equipo.equipo_cas != '' &&
                    dataRow.item.equipo.equipo_cas != null
                "
                class="d-block text-nowrap"
              >
                {{ dataRow.item.equipo.equipo_cas }}
              </span>
            </template>

            <template #cell(actions)="dataRow">
              <div v-if="dataRow.item.equipo.is_iptv">
                <b-button
                  variant="flat-info"
                  size="sm"
                  @click="
                    showIptvCredentials(dataRow.item.equipo)
                  "
                >
                  <feather-icon icon="EyeIcon" />
                  <span class="align-middle"> TV+</span>
                </b-button>
              </div>
              <div v-else>
                <span class="text-muted">-</span>
              </div>
            </template>

            <template #cell(acciones)="">
              <div class="text-nowrap" />
            </template>
          </b-table>
        </div>

        <b-col
          v-if="totalRows > perPage"
          cols="12"
        >
          <b-pagination
            v-model="currentPage"
            :total-rows="totalRows"
            hide-goto-end-buttons
            :per-page="perPage"
            align="center"
            aria-controls="my-table"
            size="md"
            first-number
            last-number
            prev-class="prev-item"
            next-class="next-item"
          />
        </b-col>
      </div>
    </b-card>

    <!-- Modal para mostrar credenciales IPTV -->
    <b-modal
      ref="iptvCredentialsModal"
      title="Credenciales TV+"
      hide-footer
      centered
      size="md"
    >
      <div v-if="selectedIptvData">
        <div class="text-center mb-3">
          <b-avatar
            :variant="`light-${selectedIptvData.tipoprodclass}`"
            size="50"
          >
            <feather-icon
              :icon="selectedIptvData.tipoprodicono"
              size="20"
            />
          </b-avatar>
          <h5 class="mb-0 mt-2">
            {{ selectedIptvData.serial }}
          </h5>
        </div>

        <div class="mb-3">
          <label
            class="form-label text-muted small mb-1"
          >Usuario</label>
          <div class="input-group">
            <b-form-input
              :value="selectedIptvData.iptv_user || 'N/A'"
              readonly
              class="iptv-credential-input"
            />
            <div class="input-group-append">
              <b-button
                variant="flat-secondary"
                class="btn-icon"
                @click="
                  copyToClipboard(selectedIptvData.iptv_user)
                "
              >
                <feather-icon
                  icon="CopyIcon"
                  size="16"
                />
              </b-button>
            </div>
          </div>
        </div>

        <div class="mb-4">
          <label
            class="form-label text-muted small mb-1"
          >Contraseña</label>
          <div class="input-group">
            <b-form-input
              :value="selectedIptvData.iptv_password || 'N/A'"
              readonly
              class="iptv-credential-input"
            />
            <div class="input-group-append">
              <b-button
                variant="flat-secondary"
                class="btn-icon"
                @click="
                  copyToClipboard(
                    selectedIptvData.iptv_password
                  )
                "
              >
                <feather-icon
                  icon="CopyIcon"
                  size="16"
                />
              </b-button>
            </div>
          </div>
        </div>

        <div class="text-center">
          <b-button
            variant="primary"
            @click="$refs.iptvCredentialsModal.hide()"
          >
            Cerrar
          </b-button>
        </div>
      </div>
    </b-modal>
  </div>
</template>

<script>
import {
  BAvatar,
  BBadge,
  BButton,
  BCard,
  BCardHeader,
  BCol,
  BFormInput,
  BMedia,
  BModal,
  BPagination,
  BSpinner,
  BTable,
} from "bootstrap-vue"
import Ripple from "vue-ripple-directive"
import toast from "../js/useNotification"
import useList from "./useList"

export default {
  components: {
    BCol,
    BCard,
    BCardHeader,
    BButton,
    BTable,
    BSpinner,
    BBadge,
    BPagination,
    BAvatar,
    BMedia,
    BFormInput,
    BModal,
  },
  directives: {
    Ripple,
  },
  props: {
    idcontrato: {
      type: Number,
      required: true,
    },
    data: {
      type: Object,
      required: false,
      default: null,
    },
  },
  setup() {
    const {
      perPage,
      currentPage,
      perPageOptions,
      searchQuery,
      sortBy,
      isSortDirDesc,
      refUserListTable,
      refetchData,
    } = useList()

    return {
      perPage,
      currentPage,
      perPageOptions,
      searchQuery,
      sortBy,
      isSortDirDesc,
      refUserListTable,
      refetchData,
    }
  },
  data() {
    return {
      userData: JSON.parse(localStorage.getItem("userData")),
      working: false,
      dataReport: [],
      selectedIptvData: null,
      columns: [
        { key: "serial", label: "serial", sortable: true },
        {
          key: "equipo.date",
          label: "Fecha",
          sortable: true,
          formatter: "dateFormat",
        },
        { key: "equipo.location", label: "ubicacion", sortable: true },
        {
          key: "equipo.packages",
          label: "paquete",
          sortable: true,
          formatter: "formatPlan",
          sortByFormatted: true,
        },
        {
          key: "estado",
          label: "estado",
          sortable: true,
          formatter: "formatStatus",
          sortByFormatted: true,
        },
        {
          key: "actions",
          label: "",
          sortable: false,
        },
      ],
      header: {},
    }
  },
  computed: {
    totalRows() {
      return this.dataReport.length
    },
  },
  created() {
    if (this.data != null) {
      this.header = {
        codigo: this.data.codigo,
        apenom: this.data.apenom,
      }
    }
    if (typeof this.idcontrato !== "undefined") {
      this.search()
    }
  },
  methods: {
    newForm() {
      this.$router.go(0)
    },
    search() {
      this.working = true
      this.$http
        .get("/contrato-equipo", {
          params: {
            idcontrato: this.idcontrato,
            idusuario: this.userData.id,
          },
        })
        .then((response) => {
          this.working = false
          this.dataReport = response.data.data
        })
        .catch((error) => {
          this.working = false
          console.log(error)
          this.$swal({
            title: "Error",
            text: error.response.data.error,
            icon: "error",
            customClass: {
              confirmButton: "btn btn-danger",
            },
            buttonsStyling: false,
          })
        })
    },
    showIptvCredentials(equipo) {
      this.selectedIptvData = equipo
      this.$refs.iptvCredentialsModal.show()
    },
    copyToClipboard(text) {
      if (text && text !== "N/A") {
        navigator.clipboard
          .writeText(text)
          .then(() => {
            toast("CheckIcon", "success", "Copiado")
          })
          .catch(() => {
            toast("XIcon", "error", "No se pudo copiar el texto")
          })
      }
    },
    reload() {
      this.search()
    },
    formatPlan(value) {
      if (value && value.length > 0) {
        return `${value[0].name} - ${value[0].price}`
      }

      return ""
    },
    dateFormat(string) {
      if (string == null) return ""

      return string.split("-").reverse().join("/")
    },
  },
}
</script>

<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";
</style>

<style lang="scss" scoped>
.iptv-credential-input {
    font-family: var(--tm-font-mono);
    background-color: var(--tm-surface-muted);
    text-align: left;
}
</style>
